/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';

import { uploadClients, getCsvClientModel } from '../app/store/actions/clients';
import UploadFilesComponent from '../components/upload';
import ClientImportErrors from '../components/upload/ClientImportErrors';
import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';

class UploadClientsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
    };
  }

  sendFile = async (file) => {
    await this.setState({ errors: {} });
    const result = await this.props.uploadClients(file);
    await this.setState({ errors: (result && result.errors) || [] });
  }

  modelDownload = async () => {
    await this.props.getCsvClientModel();
  }

  goBack = () => {
    history.push(ROUTES.CLIENTS);
  }

  render() {
    const { errors } = this.state;

    return (
      <div className="main-div-tables">
        <div className="main-table">
          <h2><Translate value="importClients" /></h2>

          <div className="upload-text">
            <p><strong><Translate value="importText1" /></strong></p>
            <p><Translate value="importText2" /></p>
            <p><Translate value="importText3" /></p>
            <p><Translate value="clientImportText4" /></p>
            <p><Translate value="clientImportText5" /></p>
            <p><Translate value="clientImportText6" /></p>
            <p><Translate value="clientImportText7" /></p>
            <p><Translate value="clientImportText8" /></p>
            <p><Translate value="clientImportText9" /></p>
            <p><Translate value="clientImportText10" /></p>
            <p><Translate value="clientImportText11" /></p>
            <p><Translate value="clientImportText12" /></p>
            <p><Translate value="clientImportText29" /></p>
            <p><Translate value="clientImportText13" /></p>
            <p><Translate value="clientImportText14" /></p>
            <p><Translate value="clientImportText15" /></p>
            <p><Translate value="clientImportText16" /></p>
            <p><Translate value="clientImportText17" /></p>
            <p><Translate value="clientImportText18" /></p>
            <p><Translate value="clientImportText19" /></p>
            <p><Translate value="clientImportText20" /></p>
            <p><Translate value="clientImportText21" /></p>
            <p><Translate value="clientImportText22" /></p>
            <p><Translate value="clientImportText23" /></p>
            <p><Translate value="clientImportText27" /></p>
          </div>

          <UploadFilesComponent
            sendFile={this.sendFile}
            goBack={this.goBack}
            modelDownload={this.modelDownload}
            itemsErrors={<ClientImportErrors errors={errors} />}
          />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  uploadClients: file => dispatch(uploadClients(file)),
  getCsvClientModel: () => dispatch(getCsvClientModel()),
});

export default connect(null, mapDispatchToProps)(UploadClientsPage);
